export default function (object, path) { // Can pass a path like a.b and it will get it from the object
  // eslint-disable-next-line no-new-func
  return new Function('_', `return _.${path}`)(object);
}
